import { render, staticRenderFns } from "./bfcard.vue?vue&type=template&id=dabeb47c&scoped=true&"
import script from "./bfcard.vue?vue&type=script&lang=js&"
export * from "./bfcard.vue?vue&type=script&lang=js&"
import style0 from "./bfcard.vue?vue&type=style&index=0&id=dabeb47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabeb47c",
  null
  
)

export default component.exports